// AC SPECS BEYOND THE CATALOGUE (Oct 2026), for the AC guides.
//
// From each model's page on daikinindia.com, quoted as Daikin prints them:
//   amps       "Operating Current (Cooling)", A: what the AC draws at full power.
//   minKw      the bottom of "Cooling Capacity (Min. ~ Max)", kW: how far an
//              inverter can turn itself down. null for a fixed-speed AC.
//   maxKw      the top of that range. The room model does not use it: like the
//              AC calculator, it takes rated kW as full power and derates it
//              above the series' full-capacity temperature (data/highlights.js).
//   volts      "Operating Voltage Range", V: [low, high].
//   ambient    "Ambient Cooling Range", °C outside: [low, high].
//   minDb      "Minimum IDU Sound Level", dBA. Daikin notes these are lab
//              (anechoic) figures and a real room is usually a little louder.
//   swing      true when the page ticks "Patented Swing Compressor".
//   stabiliser 'inside' ("Stabilizer Inside") or 'free' ("Stabilizer Free"),
//              for the variant we sell.
//   idu, odu   indoor and outdoor unit size, H × W × D.
//
// Full power in kW is taken as 230 V × amps. A power factor a little under 1
// makes the true figure slightly lower, for every AC alike.
//
// The GTQ50 we sell is FTQ50XV16UCA with the piping kit and GTQ50XV16UCA
// without it (data/catalogue.js), so its page is the FTQ50 page.
//
// Only models listed here can be compared hour by hour, and only the fields a
// model has show in the guides. Add a model by copying its figures from its
// Daikin page, with the page as `src`.
//
// No imports: scripts/prerender.js loads this file by stripping `export`.

export const AC_SPECS = {
  'gtq-50': {
    amps: 5.8, minKw: null, maxKw: null, volts: [160, 264], ambient: [19.4, 50], minDb: 38,
    swing: false, stabiliser: 'free', idu: '298 × 885 × 229 mm', odu: '595 × 845 × 300 mm',
    src: 'https://daikinindia.com/products-services/split-hi-wall-air-conditioner/atkm/5.2/ftq50u',
  },
  'gtkc-50': {
    amps: 7.17, minKw: 1.5, maxKw: 5.3, volts: [130, 285], ambient: [20, 52], minDb: 32,
    swing: true, stabiliser: 'inside',
    src: 'https://www.daikinindia.com/products-services/split-hi-wall-air-conditioner/gtkc/5.0/gtkc50',
  },
  'gtkl-50': {
    amps: 7.17, minKw: 1.4, maxKw: 5.3, volts: [130, 285], ambient: [16, 52], minDb: 32,
    swing: true, stabiliser: 'inside', idu: '298 × 885 × 239 mm', odu: '595 × 845 × 300 mm',
    src: 'https://daikinindia.com/products-services/split-ac-residential/gtkl/5-1.5/gtkl50u',
  },
  'gtkm-50': { amps: 5.51, minKw: 1.58, maxKw: 5.9, src: 'https://daikinindia.com/node/36465' },
  'ftku-50': {
    amps: 5.51, minKw: 1.58, maxKw: 5.9, volts: [130, 285], ambient: [10, 55], minDb: 31,
    swing: true, stabiliser: 'inside',
    src: 'https://daikinindia.com/product-category/splitac/standard-series/FTKU50XV',
  },
  'jtkj-53': { amps: 5.93, minKw: 1.58, maxKw: 6.0, src: 'https://daikinindia.com/node/36449' },
};

export const VOLTS = 230;
export const fullKw = (id) => (AC_SPECS[id] ? (AC_SPECS[id].amps * VOLTS) / 1000 : null);
